"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _assertThisInitialized = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var _a;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientNear = void 0;
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
var near_api_js_1 = require("near-api-js");
var AppRequest_1 = require("../types/AppRequest");
var ClientMessages_1 = require("../types/ClientMessages");
var ServerMessage_1 = require("../types/ServerMessage");
var utils_1 = require("../utils");
var ClientNear = /*#__PURE__*/function (_eventemitter3_1$defa) {
  _inherits(ClientNear, _eventemitter3_1$defa);
  var _super = _createSuper(ClientNear);
  function ClientNear(ws, sessionId) {
    var _this;
    _classCallCheck(this, ClientNear);
    _this = _super.call(this);
    _this.events = {};
    _this.sessionId = '';
    _this.connect = function (_ref) {
      var publicKey = _ref.publicKey,
        sessionId = _ref.sessionId,
        token = _ref.token,
        device = _ref.device,
        accountId = _ref.accountId,
        notificationEndpoint = _ref.notificationEndpoint;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var request;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = (0, ClientMessages_1.createConnectMessage)(Buffer.from(publicKey.data).toString('hex'), sessionId, token, notificationEndpoint, device, JSON.stringify({
                accountId: accountId
              }));
              _context.next = 3;
              return this.send(request);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    };
    _this.endSession = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var request;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = {
                type: ClientMessages_1.ClientMessageTypes.EndSession,
                sessionId: this.sessionId
              };
              _context2.next = 3;
              return this.send(request);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    };
    _this.getSessions = function (token) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var request;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = {
                type: ClientMessages_1.ClientMessageTypes.GetSessions,
                token: token
              };
              _context3.next = 3;
              return this.send(request);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    };
    _this.getPendingRequests = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var request;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              request = {
                type: ClientMessages_1.ClientMessageTypes.GetPendingRequests,
                sessionId: this.sessionId
              };
              _context4.next = 3;
              return this.send(request);
            case 3:
              return _context4.abrupt("return", _context4.sent);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    };
    _this.send = function (message) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                var id = (0, utils_1.getRandomId)();
                var request = JSON.stringify(Object.assign(Object.assign({}, message), {
                  id: id
                }));
                _this2.events[id] = function (response) {
                  if (response.type === ServerMessage_1.ServerMessageTypes.Error) {
                    reject(response.msg);
                  } else {
                    resolve(response);
                  }
                };
                _this2.ws.send(request);
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
    };
    _this.resolveSignTransaction = function (_ref2) {
      var requestId = _ref2.requestId,
        signedTransactions = _ref2.signedTransactions;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var buffers, request;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              buffers = signedTransactions.map(function (tx) {
                return Buffer.from(tx.encode()).toString('hex');
              });
              request = {
                type: ClientMessages_1.ClientMessageTypes.ResolveSignTransaction,
                sessionId: this.sessionId,
                requestId: requestId,
                signedTransactions: buffers
              };
              return _context6.abrupt("return", this.send(request));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    };
    _this.resolveSignMessage = function (_ref3) {
      var requestId = _ref3.requestId,
        signature = _ref3.signature;
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var request;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              request = {
                type: ClientMessages_1.ClientMessageTypes.ResolveSignMessage,
                sessionId: this.sessionId,
                requestId: requestId,
                signature: Buffer.from(signature).toString('hex')
              };
              return _context7.abrupt("return", this.send(request));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
    };
    _this.rejectRequest = function (requestId) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var request;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              request = {
                type: ClientMessages_1.ClientMessageTypes.RejectRequest,
                requestId: requestId
              };
              return _context8.abrupt("return", this.send(request));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    };
    _this.ws = ws;
    _this.sessionId = sessionId;
    return _this;
  }
  return _createClass(ClientNear);
}(eventemitter3_1.default);
exports.ClientNear = ClientNear;
_a = ClientNear;
ClientNear.build = function (_ref4) {
  var sessionId = _ref4.sessionId,
    url = _ref4.url;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", new Promise(function (resolve, reject) {
            var ws = url ? new isomorphic_ws_1.default(url) : new isomorphic_ws_1.default('wss://relay.nightly.app/client');
            var connection = new ClientNear(ws, sessionId);
            connection.ws.onopen = function () {
              connection.ws.onmessage = function (_ref5) {
                var data = _ref5.data;
                var response = JSON.parse(data);
                if (response.type === ServerMessage_1.ServerMessageTypes.NewRequestMessage) {
                  if (response.request.type == AppRequest_1.AppRequest.SignTransaction || response.request.type == AppRequest_1.AppRequest.SignAllTransactions) {
                    var withDeserialized = Object.assign({
                      deserialized: response.request.transactions.map(function (hex) {
                        return near_api_js_1.transactions.Transaction.decode(Buffer.from(hex, 'hex'));
                      })
                    }, response.request);
                    connection.emit('newRequest', withDeserialized);
                  } else connection.emit('newRequest', response.request);
                  return;
                } else {
                  connection.events[response.id](response);
                }
              };
              connection.ws.onclose = function () {
                connection.emit('disconnect');
              };
              var id = (0, utils_1.getRandomId)();
              var request = {
                id: id,
                sessionId: sessionId,
                type: ClientMessages_1.ClientMessageTypes.GetInfo
              };
              connection.events[id] = function (response) {
                if (response.type === ServerMessage_1.ServerMessageTypes.AppData) {
                  resolve({
                    client: connection,
                    data: response
                  });
                } else {
                  reject(response);
                }
              };
              connection.ws.send(JSON.stringify(request));
            };
          }));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
};